module.exports = __webpack_public_path__ + "img/l1ss.d48c8db0.png";